const normalizeComposerAttachmentEntry = (item = null) => {
  const normalizedId = String(item?.id || '').trim();

  if (!normalizedId) {
    return null;
  }

  const normalizedProgressPercent = Number(item?.uploadProgressPercent);
  const compatibility =
    item?.compatibility && typeof item.compatibility === 'object' && !Array.isArray(item.compatibility)
      ? {
          ...item.compatibility
        }
      : null;

  return {
    id: normalizedId,
    name: String(item?.name || item?.filename || 'attachment').trim() || 'attachment',
    sizeBytes: Math.max(0, Number(item?.sizeBytes || 0)),
    mimeType:
      String(item?.mimeType || '')
        .trim()
        .toLowerCase() || 'application/octet-stream',
    mediaKind:
      String(item?.mediaKind || '')
        .trim()
        .toLowerCase() || '',
    status:
      String(item?.status || '')
        .trim()
        .toLowerCase() || 'ready',
    error: String(item?.error || ''),
    uploadProgressPercent: Number.isFinite(normalizedProgressPercent) ? Math.max(0, Math.min(100, Math.round(normalizedProgressPercent))) : 0,
    uploadResult: item?.uploadResult && typeof item.uploadResult === 'object' ? item.uploadResult : null,
    compatibility
  };
};

export default normalizeComposerAttachmentEntry;
